import SectionCard from "../../Components/SectionCard";
import Switch from "react-switch";
import TextboxSet from "../../Components/TextboxSet";
import ImageUpload from "../../Components/ImageUpload";
import { XMarkIcon } from "@heroicons/react/24/solid";
import Button from "../../Components/Button";
import { Trash } from "iconsax-react";

const MonetaryContribution = ({
  monetaryContributionSettings,
  setMonetaryContributionSettings,
}) => {
  const radioList = [
    {
      id: 1,
      value: "occurlab",
      label: "Through Occurlab",
    },
    {
      id: 2,
      value: "qr",
      label: "Upload QR Code",
    },
  ];

  const onChange = (event) => {
    const { name, value } = event.target;
    setMonetaryContributionSettings({
      ...monetaryContributionSettings,
      [name]: value,
    });
  };

  const handleImageChange = (value) => {
    setMonetaryContributionSettings({
      ...monetaryContributionSettings,
      qr_code: value,
    });
  };

  const handleRemoveImage = () => {
    setMonetaryContributionSettings({
      ...monetaryContributionSettings,
      qr_code: "",
    });
  };

  return (
    <SectionCard title="Monetary Contribution Settings">
      <div className="flex flex-col gap-6 p-[24px]">
        <div className="flex items-center gap-4">
          <Switch
            checked={Boolean(monetaryContributionSettings.accept_contribution)}
            onChange={() =>
              setMonetaryContributionSettings({
                ...monetaryContributionSettings,
                accept_contribution:
                  !monetaryContributionSettings.accept_contribution,
              })
            }
            checkedIcon={false}
            uncheckedIcon={false}
            offColor="#EFF0F2"
            onColor="#5C4BF5"
            width={48}
            height={28}
          />
          <p>Accept Monetary Contribution and Payment</p>
        </div>

        <div
          className={`${
            !monetaryContributionSettings.accept_contribution
              ? "text-[#D0D3D8]"
              : ""
          }`}
        >
          <TextboxSet
            name="monetary_title"
            label="Title"
            value={monetaryContributionSettings.monetary_title}
            onChange={(e) => {
              onChange(e);
            }}
            disabled={!monetaryContributionSettings.accept_contribution}
          />
        </div>

        <div
          className={`${
            !monetaryContributionSettings.accept_contribution
              ? "text-[#D0D3D8]"
              : ""
          }`}
        >
          <TextboxSet
            name="monetary_description"
            label="Description"
            value={monetaryContributionSettings.monetary_description}
            onChange={(e) => {
              onChange(e);
            }}
            disabled={!monetaryContributionSettings.accept_contribution}
          />
        </div>

        <div
          className={`flex items-center gap-4 ${
            !monetaryContributionSettings.accept_contribution
              ? "text-[#D0D3D8]"
              : ""
          }`}
        >
          {radioList &&
            radioList.map((item) => (
              <div className="flex flex-col w-fit gap-[14px]">
                <div className="flex gap-[8px] items-center">
                  <input
                    name="receive_options"
                    type="radio"
                    className="size-6 accent-[#5C4BF5] hover:cursor-pointer"
                    checked={
                      monetaryContributionSettings.receive_options === item.id
                    }
                    onChange={() =>
                      setMonetaryContributionSettings({
                        ...monetaryContributionSettings,
                        receive_options: item.id,
                      })
                    }
                    disabled={!monetaryContributionSettings.accept_contribution}
                  />
                  <label>{item.label}</label>
                </div>
              </div>
            ))}
        </div>

        {monetaryContributionSettings.receive_options === 1 && (
          <div
            className={`flex flex-col w-full gap-2 ${
              !monetaryContributionSettings.accept_contribution
                ? "text-[#D0D3D8]"
                : ""
            }`}
          >
            <label>Amount Options</label>
            {monetaryContributionSettings.amount_options &&
              monetaryContributionSettings.amount_options.map((option, idx) => (
                <div
                  className="flex items-center gap-2 border rounded-md p-3"
                  key={idx}
                >
                  <label className="text-[#A1A7B2]">RM</label>
                  <input
                    value={option}
                    className="w-full border-none outline-none"
                    type="number"
                    onChange={(e) => {
                      const newOptions = [
                        ...monetaryContributionSettings.amount_options,
                      ];
                      newOptions[idx] = e.target.value;
                      setMonetaryContributionSettings({
                        ...monetaryContributionSettings,
                        amount_options: newOptions,
                      });
                    }}
                    disabled={!monetaryContributionSettings.accept_contribution}
                  />
                  <Trash
                    size="16"
                    color="#FF0000"
                    className="cursor-pointer"
                    onClick={() => {
                      if (monetaryContributionSettings.accept_contribution) {
                        const newOptions =
                          monetaryContributionSettings.amount_options.filter(
                            (_, index) => index !== idx
                          );
                        setMonetaryContributionSettings({
                          ...monetaryContributionSettings,
                          amount_options: newOptions,
                        });
                      }
                    }}
                  />
                </div>
              ))}
            {monetaryContributionSettings.amount_options.length < 7 && (
              <Button
                onClick={() => {
                  setMonetaryContributionSettings({
                    ...monetaryContributionSettings,
                    amount_options: [
                      ...monetaryContributionSettings.amount_options,
                      "",
                    ],
                  });
                }}
                disabled={Boolean(
                  !monetaryContributionSettings.accept_contribution
                )}
              >
                Add Amount Option +
              </Button>
            )}
          </div>
        )}

        {monetaryContributionSettings.receive_options === 2 && (
          <div className="flex flex-col w-full">
            <ImageUpload handleChange={handleImageChange} />
            {monetaryContributionSettings.qr_code && (
              <div className="relative flex flex-col w-full max-h-[200px] bg-black rounded-xl justify-center items-center">
                <div className="absolute left-[20px] top-[8px] flex items-center gap-[18px]">
                  <XMarkIcon
                    className="size-[16px] h-fit text-white hover:cursor-pointer"
                    onClick={() => handleRemoveImage()}
                  />
                  <p className="h-fit text-white font-normal">
                    {decodeURIComponent(
                      monetaryContributionSettings.qr_code
                        .split("?")[0]
                        .split("/")
                        .pop()
                    )}
                  </p>
                </div>
                <img
                  src={monetaryContributionSettings.qr_code}
                  alt="event-image"
                  className="h-[200px] object-contain"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </SectionCard>
  );
};

export default MonetaryContribution;
